import {lazy} from 'react';

export const SocialMediaFeedLazy = lazy(() => import(/* webpackChunkName: "socialMediaFeed" */ '.'));
